import { render, staticRenderFns } from "./input-file-cmp-extended.vue?vue&type=template&id=3cfa214e&scoped=true"
import script from "./input-file-cmp-extended.vue?vue&type=script&lang=js"
export * from "./input-file-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./input-file-cmp-extended.vue?vue&type=style&index=0&id=3cfa214e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa214e",
  null
  
)

export default component.exports